import { Building2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export function SchoolBadge({
  className,
  withIcon = true,
}: {
  className?: string;
  withIcon?: boolean;
}) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "text-[10px] uppercase tracking-wide font-semibold border-indigo-200 bg-indigo-50 text-indigo-700 px-1.5 py-0",
        className,
      )}
      data-testid="badge-school"
    >
      {withIcon && <Building2 className="h-2.5 w-2.5 mr-0.5" />}
      School
    </Badge>
  );
}
